import React, { useEffect, useState } from "react";
import classes from './Payment.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav2';
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { Eye, Edit, Trash } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";

const Payments = () => {
    const location = useLocation();
      const navigate = useNavigate();

    const data = [
        { payment: 'PAY-002', payee: 'Dangote Group', date: '2025-01-15', amount: '₦2,000,000.00', method: 'Transfer', ref: 'SAL-FEB', account: 'Access Bank 00112233', status: 'Paid' },
        { payment: 'PAY-002', payee: 'Dangote Group', date: '2025-01-15', amount: '₦2,000,000.00', method: 'Cash', ref: 'SAL-FEB', account: 'Access Bank 00112233', status: 'Pending' },
        { payment: 'PAY-002', payee: 'Dangote Group', date: '2025-01-15', amount: '₦2,000,000.00', method: 'Transfer', ref: 'SAL-FEB', account: 'Access Bank 00112233', status: 'Paid' },
        { payment: 'PAY-002', payee: 'Dangote Group', date: '2025-01-15', amount: '₦2,000,000.00', method: 'Cash', ref: 'SAL-FEB', account: 'Access Bank 00112233', status: 'Pending' },
        { payment: 'PAY-002', payee: 'Dangote Group', date: '2025-01-15', amount: '₦2,000,000.00', method: 'Transfer', ref: 'SAL-FEB', account: 'Access Bank 00112233', status: 'Paid' },
        { payment: 'PAY-002', payee: 'Dangote Group', date: '2025-01-15', amount: '₦2,000,000.00', method: 'Cash', ref: 'SAL-FEB', account: 'Access Bank 00112233', status: 'Pending' },

    ];
    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const handleNewPayment = () => {
        navigate('new_payment')
    }

        useEffect(() => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
        document.head.appendChild(link);
        return () => {
          document.head.removeChild(link);
        };
      }, []);
    

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Payments</h2>
                    <h1 className={classes.Titles}>
                        Manage your purchase transactions, supplier invoices, and payments.
                    </h1>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Payments</p>
                                <p className={classes.kdptg1}>₦8,400,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Completed</p>
                                <p className={classes.kdptg2}>₦4,950,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Pending payments</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Overdue</p>
                                <p className={classes.kdptg3}>₦3,200,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Past due dates</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Pending</p>
                                <p className={classes.kdptg4}>15</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Total invoices</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                            <input type="text" className={classes.searchBar} placeholder="Search sales" />
                        </div>
                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All Methods</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBars} placeholder="Filter..." />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>
                    <button className={classes.btnss} onClick={handleNewPayment}> + New purchases</button>
                </div>

                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>Payments #</th>
                                <th>Payee</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Method</th>
                                <th>Refrence</th>
                                <th>Account</th>
                                <th>status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) => (
                                <tr key={index} className={classes.tableRow}>
                                    <td className={classes.tableCell}>{row.payment}</td>
                                    <td className={classes.tableCell}>{row.payee}</td>
                                    <td className={classes.tableCell}>{row.date}</td>
                                    <td className={classes.tableCell3}>{row.amount}</td>
                                    <td className={classes.tableCell}>{row.method}</td>
                                    <td className={classes.tableCell}>{row.ref}</td>
                                    <td className={classes.tableCell}>{row.account}</td>
                                    <td className={classes.tableCell}>
                                        <span className={`${classes.statusButton} ${classes['status' + row.status]}`}>
                                            {row.status}
                                        </span>
                                    </td>
                                    {/* <td className={classes.tableCell}>{row.action}</td> */}
                                    {/* <td className={classes.tableCell}>{row.type}</td> */}
                                    <td className={classes.tableCell}>
                                        <div className={classes.actionIcons}>
                                            <Eye size={16} style={{ color: 'rgba(22, 163, 74, 1)' }} />
                                            <Edit size={16} style={{ margin: '0 8px', color: 'rgba(37, 99, 235, 1)' }} />
                                            <Trash size={16} style={{ color: 'rgba(255, 191, 0, 1)' }} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.page}>2</td>
                            <td>Last</td>
                        </tr>
                        <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>

                    </tfoot>

                </table>
            </div>
            <Footer />

        </div>
    );
};

export default Payments;
